module.exports = __webpack_public_path__ + "img/trust-blue.92641051.png";